<template>
    <b-row align-v="center" align-h="between" class="fup-paginator">
        <b-col class="text-muted pl-0" v-if="!minimize">
            <template v-if="perPage">
                {{(perPage * value - perPage) + 1}} – {{perPage * value > totalRows ? totalRows : perPage * value}}
                <template v-if="(perPage * value > totalRows ? totalRows : perPage * value) < 9999">
                    из {{totalRows}}
                </template>
            </template>
            <template v-else-if="totalRows">
                Всего {{totalRows}}
            </template>
        </b-col>
        <b-pagination
                v-if="perPage && totalRows > perPage"
                v-bind="$attrs"
                class="m-0"
                size="sm"
                :total-rows="totalRows"
                :value="value"
                @input="changed"
                :per-page="perPage"></b-pagination>

    </b-row>
</template>

<script>
    export default {
        name: "Paginator",
        props: {
            value: null,
            perPage: {
                type: Number,
                default: 0
            },
            totalRows: {
                type: Number,
                default: 0
            },
            minimize: false,
        },
        methods: {
            changed(value) {
                this.$emit('input', value)
            }
        }
    }
</script>

<style scoped>

</style>